/**
 * @fileoverview gRPC-Web generated client stub for reportpb
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var google_type_date_pb = require('../../google/type/date_pb.js')

var proto_commonpb_file_pb = require('../../proto/commonpb/file_pb.js')

var proto_utilspb_pagination_pb = require('../../proto/utilspb/pagination_pb.js')

const proto = {};
proto.reportpb = require('./activity_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.reportpb.ActivityServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.reportpb.ActivityServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reportpb.ListActivityRequest,
 *   !proto.reportpb.ListActivityResponse>}
 */
const methodDescriptor_ActivityService_ListActivity = new grpc.web.MethodDescriptor(
  '/reportpb.ActivityService/ListActivity',
  grpc.web.MethodType.UNARY,
  proto.reportpb.ListActivityRequest,
  proto.reportpb.ListActivityResponse,
  /**
   * @param {!proto.reportpb.ListActivityRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.ListActivityResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.reportpb.ListActivityRequest,
 *   !proto.reportpb.ListActivityResponse>}
 */
const methodInfo_ActivityService_ListActivity = new grpc.web.AbstractClientBase.MethodInfo(
  proto.reportpb.ListActivityResponse,
  /**
   * @param {!proto.reportpb.ListActivityRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.ListActivityResponse.deserializeBinary
);


/**
 * @param {!proto.reportpb.ListActivityRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.reportpb.ListActivityResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reportpb.ListActivityResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reportpb.ActivityServiceClient.prototype.listActivity =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reportpb.ActivityService/ListActivity',
      request,
      metadata || {},
      methodDescriptor_ActivityService_ListActivity,
      callback);
};


/**
 * @param {!proto.reportpb.ListActivityRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reportpb.ListActivityResponse>}
 *     Promise that resolves to the response
 */
proto.reportpb.ActivityServicePromiseClient.prototype.listActivity =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reportpb.ActivityService/ListActivity',
      request,
      metadata || {},
      methodDescriptor_ActivityService_ListActivity);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reportpb.ListActivityRequest,
 *   !proto.reportpb.ListActivityResponse>}
 */
const methodDescriptor_ActivityService_ListActivityDetails = new grpc.web.MethodDescriptor(
  '/reportpb.ActivityService/ListActivityDetails',
  grpc.web.MethodType.UNARY,
  proto.reportpb.ListActivityRequest,
  proto.reportpb.ListActivityResponse,
  /**
   * @param {!proto.reportpb.ListActivityRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.ListActivityResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.reportpb.ListActivityRequest,
 *   !proto.reportpb.ListActivityResponse>}
 */
const methodInfo_ActivityService_ListActivityDetails = new grpc.web.AbstractClientBase.MethodInfo(
  proto.reportpb.ListActivityResponse,
  /**
   * @param {!proto.reportpb.ListActivityRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.ListActivityResponse.deserializeBinary
);


/**
 * @param {!proto.reportpb.ListActivityRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.reportpb.ListActivityResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reportpb.ListActivityResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reportpb.ActivityServiceClient.prototype.listActivityDetails =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reportpb.ActivityService/ListActivityDetails',
      request,
      metadata || {},
      methodDescriptor_ActivityService_ListActivityDetails,
      callback);
};


/**
 * @param {!proto.reportpb.ListActivityRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reportpb.ListActivityResponse>}
 *     Promise that resolves to the response
 */
proto.reportpb.ActivityServicePromiseClient.prototype.listActivityDetails =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reportpb.ActivityService/ListActivityDetails',
      request,
      metadata || {},
      methodDescriptor_ActivityService_ListActivityDetails);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reportpb.UpdateActivityRequest,
 *   !proto.reportpb.UpdateActivityResponse>}
 */
const methodDescriptor_ActivityService_UpdateActivity = new grpc.web.MethodDescriptor(
  '/reportpb.ActivityService/UpdateActivity',
  grpc.web.MethodType.UNARY,
  proto.reportpb.UpdateActivityRequest,
  proto.reportpb.UpdateActivityResponse,
  /**
   * @param {!proto.reportpb.UpdateActivityRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.UpdateActivityResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.reportpb.UpdateActivityRequest,
 *   !proto.reportpb.UpdateActivityResponse>}
 */
const methodInfo_ActivityService_UpdateActivity = new grpc.web.AbstractClientBase.MethodInfo(
  proto.reportpb.UpdateActivityResponse,
  /**
   * @param {!proto.reportpb.UpdateActivityRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.UpdateActivityResponse.deserializeBinary
);


/**
 * @param {!proto.reportpb.UpdateActivityRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.reportpb.UpdateActivityResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reportpb.UpdateActivityResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reportpb.ActivityServiceClient.prototype.updateActivity =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reportpb.ActivityService/UpdateActivity',
      request,
      metadata || {},
      methodDescriptor_ActivityService_UpdateActivity,
      callback);
};


/**
 * @param {!proto.reportpb.UpdateActivityRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reportpb.UpdateActivityResponse>}
 *     Promise that resolves to the response
 */
proto.reportpb.ActivityServicePromiseClient.prototype.updateActivity =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reportpb.ActivityService/UpdateActivity',
      request,
      metadata || {},
      methodDescriptor_ActivityService_UpdateActivity);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reportpb.PageViewActivityRequest,
 *   !proto.reportpb.ListActivityResponse>}
 */
const methodDescriptor_ActivityService_PageViewActivity = new grpc.web.MethodDescriptor(
  '/reportpb.ActivityService/PageViewActivity',
  grpc.web.MethodType.UNARY,
  proto.reportpb.PageViewActivityRequest,
  proto.reportpb.ListActivityResponse,
  /**
   * @param {!proto.reportpb.PageViewActivityRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.ListActivityResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.reportpb.PageViewActivityRequest,
 *   !proto.reportpb.ListActivityResponse>}
 */
const methodInfo_ActivityService_PageViewActivity = new grpc.web.AbstractClientBase.MethodInfo(
  proto.reportpb.ListActivityResponse,
  /**
   * @param {!proto.reportpb.PageViewActivityRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.ListActivityResponse.deserializeBinary
);


/**
 * @param {!proto.reportpb.PageViewActivityRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.reportpb.ListActivityResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reportpb.ListActivityResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reportpb.ActivityServiceClient.prototype.pageViewActivity =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reportpb.ActivityService/PageViewActivity',
      request,
      metadata || {},
      methodDescriptor_ActivityService_PageViewActivity,
      callback);
};


/**
 * @param {!proto.reportpb.PageViewActivityRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reportpb.ListActivityResponse>}
 *     Promise that resolves to the response
 */
proto.reportpb.ActivityServicePromiseClient.prototype.pageViewActivity =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reportpb.ActivityService/PageViewActivity',
      request,
      metadata || {},
      methodDescriptor_ActivityService_PageViewActivity);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reportpb.PageViewActivityRequest,
 *   !proto.reportpb.ListActivityResponse>}
 */
const methodDescriptor_ActivityService_PageViewActivityDetails = new grpc.web.MethodDescriptor(
  '/reportpb.ActivityService/PageViewActivityDetails',
  grpc.web.MethodType.UNARY,
  proto.reportpb.PageViewActivityRequest,
  proto.reportpb.ListActivityResponse,
  /**
   * @param {!proto.reportpb.PageViewActivityRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.ListActivityResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.reportpb.PageViewActivityRequest,
 *   !proto.reportpb.ListActivityResponse>}
 */
const methodInfo_ActivityService_PageViewActivityDetails = new grpc.web.AbstractClientBase.MethodInfo(
  proto.reportpb.ListActivityResponse,
  /**
   * @param {!proto.reportpb.PageViewActivityRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.ListActivityResponse.deserializeBinary
);


/**
 * @param {!proto.reportpb.PageViewActivityRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.reportpb.ListActivityResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reportpb.ListActivityResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reportpb.ActivityServiceClient.prototype.pageViewActivityDetails =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reportpb.ActivityService/PageViewActivityDetails',
      request,
      metadata || {},
      methodDescriptor_ActivityService_PageViewActivityDetails,
      callback);
};


/**
 * @param {!proto.reportpb.PageViewActivityRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reportpb.ListActivityResponse>}
 *     Promise that resolves to the response
 */
proto.reportpb.ActivityServicePromiseClient.prototype.pageViewActivityDetails =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reportpb.ActivityService/PageViewActivityDetails',
      request,
      metadata || {},
      methodDescriptor_ActivityService_PageViewActivityDetails);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reportpb.DownloadTradeConfirmationRequest,
 *   !proto.commonpb.File>}
 */
const methodDescriptor_ActivityService_DownloadTradeConfirmation = new grpc.web.MethodDescriptor(
  '/reportpb.ActivityService/DownloadTradeConfirmation',
  grpc.web.MethodType.UNARY,
  proto.reportpb.DownloadTradeConfirmationRequest,
  proto_commonpb_file_pb.File,
  /**
   * @param {!proto.reportpb.DownloadTradeConfirmationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto_commonpb_file_pb.File.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.reportpb.DownloadTradeConfirmationRequest,
 *   !proto.commonpb.File>}
 */
const methodInfo_ActivityService_DownloadTradeConfirmation = new grpc.web.AbstractClientBase.MethodInfo(
  proto_commonpb_file_pb.File,
  /**
   * @param {!proto.reportpb.DownloadTradeConfirmationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto_commonpb_file_pb.File.deserializeBinary
);


/**
 * @param {!proto.reportpb.DownloadTradeConfirmationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.commonpb.File)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.commonpb.File>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reportpb.ActivityServiceClient.prototype.downloadTradeConfirmation =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reportpb.ActivityService/DownloadTradeConfirmation',
      request,
      metadata || {},
      methodDescriptor_ActivityService_DownloadTradeConfirmation,
      callback);
};


/**
 * @param {!proto.reportpb.DownloadTradeConfirmationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.commonpb.File>}
 *     Promise that resolves to the response
 */
proto.reportpb.ActivityServicePromiseClient.prototype.downloadTradeConfirmation =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reportpb.ActivityService/DownloadTradeConfirmation',
      request,
      metadata || {},
      methodDescriptor_ActivityService_DownloadTradeConfirmation);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reportpb.ListActivityRequest,
 *   !proto.reportpb.ListActivitiesResponse>}
 */
const methodDescriptor_ActivityService_ListActivities = new grpc.web.MethodDescriptor(
  '/reportpb.ActivityService/ListActivities',
  grpc.web.MethodType.UNARY,
  proto.reportpb.ListActivityRequest,
  proto.reportpb.ListActivitiesResponse,
  /**
   * @param {!proto.reportpb.ListActivityRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.ListActivitiesResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.reportpb.ListActivityRequest,
 *   !proto.reportpb.ListActivitiesResponse>}
 */
const methodInfo_ActivityService_ListActivities = new grpc.web.AbstractClientBase.MethodInfo(
  proto.reportpb.ListActivitiesResponse,
  /**
   * @param {!proto.reportpb.ListActivityRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.ListActivitiesResponse.deserializeBinary
);


/**
 * @param {!proto.reportpb.ListActivityRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.reportpb.ListActivitiesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reportpb.ListActivitiesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reportpb.ActivityServiceClient.prototype.listActivities =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reportpb.ActivityService/ListActivities',
      request,
      metadata || {},
      methodDescriptor_ActivityService_ListActivities,
      callback);
};


/**
 * @param {!proto.reportpb.ListActivityRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reportpb.ListActivitiesResponse>}
 *     Promise that resolves to the response
 */
proto.reportpb.ActivityServicePromiseClient.prototype.listActivities =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reportpb.ActivityService/ListActivities',
      request,
      metadata || {},
      methodDescriptor_ActivityService_ListActivities);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reportpb.ListActivityRequest,
 *   !proto.reportpb.ListActivitySummary>}
 */
const methodDescriptor_ActivityService_GetActivitySummary = new grpc.web.MethodDescriptor(
  '/reportpb.ActivityService/GetActivitySummary',
  grpc.web.MethodType.UNARY,
  proto.reportpb.ListActivityRequest,
  proto.reportpb.ListActivitySummary,
  /**
   * @param {!proto.reportpb.ListActivityRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.ListActivitySummary.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.reportpb.ListActivityRequest,
 *   !proto.reportpb.ListActivitySummary>}
 */
const methodInfo_ActivityService_GetActivitySummary = new grpc.web.AbstractClientBase.MethodInfo(
  proto.reportpb.ListActivitySummary,
  /**
   * @param {!proto.reportpb.ListActivityRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.ListActivitySummary.deserializeBinary
);


/**
 * @param {!proto.reportpb.ListActivityRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.reportpb.ListActivitySummary)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reportpb.ListActivitySummary>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reportpb.ActivityServiceClient.prototype.getActivitySummary =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reportpb.ActivityService/GetActivitySummary',
      request,
      metadata || {},
      methodDescriptor_ActivityService_GetActivitySummary,
      callback);
};


/**
 * @param {!proto.reportpb.ListActivityRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reportpb.ListActivitySummary>}
 *     Promise that resolves to the response
 */
proto.reportpb.ActivityServicePromiseClient.prototype.getActivitySummary =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reportpb.ActivityService/GetActivitySummary',
      request,
      metadata || {},
      methodDescriptor_ActivityService_GetActivitySummary);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reportpb.ListActivityReportDetailsRequest,
 *   !proto.reportpb.ActivityReportDetails>}
 */
const methodDescriptor_ActivityService_ListActivityReportDetails = new grpc.web.MethodDescriptor(
  '/reportpb.ActivityService/ListActivityReportDetails',
  grpc.web.MethodType.UNARY,
  proto.reportpb.ListActivityReportDetailsRequest,
  proto.reportpb.ActivityReportDetails,
  /**
   * @param {!proto.reportpb.ListActivityReportDetailsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.ActivityReportDetails.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.reportpb.ListActivityReportDetailsRequest,
 *   !proto.reportpb.ActivityReportDetails>}
 */
const methodInfo_ActivityService_ListActivityReportDetails = new grpc.web.AbstractClientBase.MethodInfo(
  proto.reportpb.ActivityReportDetails,
  /**
   * @param {!proto.reportpb.ListActivityReportDetailsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.ActivityReportDetails.deserializeBinary
);


/**
 * @param {!proto.reportpb.ListActivityReportDetailsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.reportpb.ActivityReportDetails)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reportpb.ActivityReportDetails>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reportpb.ActivityServiceClient.prototype.listActivityReportDetails =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reportpb.ActivityService/ListActivityReportDetails',
      request,
      metadata || {},
      methodDescriptor_ActivityService_ListActivityReportDetails,
      callback);
};


/**
 * @param {!proto.reportpb.ListActivityReportDetailsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reportpb.ActivityReportDetails>}
 *     Promise that resolves to the response
 */
proto.reportpb.ActivityServicePromiseClient.prototype.listActivityReportDetails =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reportpb.ActivityService/ListActivityReportDetails',
      request,
      metadata || {},
      methodDescriptor_ActivityService_ListActivityReportDetails);
};


module.exports = proto.reportpb;

